import { bool, node, string } from 'prop-types'

import { defaultCloseComponent, getModalHeader } from './helpers'

import './ProductFilterV1Modal.scss'

export const ProductFilterV1Modal = ({
  title,
  children,
  id,
  titleHasInnerHTML,
  closeComponent,
}) => {
  const titleId = `${id}__Modal__title`

  return (
    <div
      className="m-Modal m-ProductFilterModalV1"
      id={id}
      aria-hidden="true"
      data-clientside-hook="modal productFilterModal"
    >
      <div
        className="m-Modal__dialog m-Modal__dialog--fullScreen m-ProductFilterModalV1__dialog"
        role="dialog"
        aria-labelledby={titleId}
      >
        <div
          data-clientside-hook="productFilterModal__header"
          className="m-ProductFilterModalV1__header"
        >
          {getModalHeader({
            titleId,
            title,
            titleHasInnerHTML,
          })}
          <div className="m-ProductFilterModalV1__close l-flex">
            {closeComponent}
          </div>
        </div>
        <div
          className="m-ProductFilterModalV1__content u-overflow@small-tiny"
          data-clientside-hook="productFilterModal__content"
        >
          <div className="m-ProductFilterModalV1__inner">{children}</div>
        </div>
      </div>
    </div>
  )
}

ProductFilterV1Modal.propTypes = {
  children: node.isRequired,
  title: node,
  id: string.isRequired,
  titleHasInnerHTML: bool,
  closeComponent: node,
}

ProductFilterV1Modal.defaultProps = {
  title: null,
  titleHasInnerHTML: false,
  closeComponent: defaultCloseComponent(),
}

export default ProductFilterV1Modal
